// Motsvarar <LfcCore /> i lfc-frontend, se /from_lfc-frontend/README.txt

import { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
// Not used for MOK
// import { Provider } from "react-redux";

import lfcDimensionsVisibilityJson from '../../data/lfcDimensionsVisibility'
import { getVisibleLfcDimensionsIds } from '../../helpers/getVisibleLfcDimensionsIds'

import checkConstraint from './from_lfc-frontend/lfcHelpers/checkConstraint'
import getSelectableValues from './from_lfc-frontend/lfcHelpers/getSelectableValues'
// For MOK, the lfcSlice of MOK store is used instead
// import lfcStore from "./from_lfc-frontend/lfcStore/lfcStore";
import Configurator from './from_lfc-frontend/Configurator/Configurator'

import * as Styled from './styles'

const LFC_LANGUAGE = 'SE' // behöver språkhanteras

const LFC_MESSAGES = {
  generalError: 'Något gick fel, försök igen.',
  area: 'Yta:',
  amount: 'Antal',
  bundleContains: 'Paketet innehåller:',
  pcs: 'st',
  ordinaryPrice: 'Ordinarie pris',
  save: 'Spara',
  addToCart: 'Lägg i varukorg',
  cvyAddedToCartResponse: 'Produkterna för ditt uterum har lagts till i varukorgen.',
  qliroInformation: {
    installmentFrom: 'Delbetala från',
    perMonth: '/mån.',
    noInterest: 'Räntefritt upp till 12 månader.',
  },
  DEPRECATEDfreeShipping: 'Fri frakt i hela Sverige',
  correctionInformation: {
    notAbleToSelect: 'Du kan inte välja',
    becauseYouHaveSelected: 'eftersom du har valt',
    youNeedToSelect: 'du behöver välja',
    and: 'och',
    or: 'eller',
  },
}

function Lfc({ lfcItem, chosenValues, configResult, onChange }) {
  const memoVisibileDimensionsIds = useMemo(
    () => getVisibleLfcDimensionsIds(lfcItem.dimensions, lfcDimensionsVisibilityJson),
    [lfcItem.dimensions]
  )

  const [constraints, setConstraints] = useState(checkConstraint(chosenValues, lfcItem.constraintsRules))
  const [correctionInformation, setCorrectionInformation] = useState([
    {
      dimensionId: null,
      constraint: null,
    },
  ])

  function getDimensionProperty(valueId, propertyType, language) {
    if (lfcItem.dimensions && valueId) {
      return lfcItem.dimensions.find((dimension) => dimension.values.find((value) => value.valueId === valueId))[
        `${propertyType}${language ? language : ''}`
      ]
    }
    return null
  }

  function getDimensionName(valueId) {
    return getDimensionProperty(valueId, 'dimensionName', LFC_LANGUAGE)
  }

  function getValueProperty(valueId, propertyType, language) {
    if (lfcItem.dimensions && valueId) {
      const foundDimension = lfcItem.dimensions.find((dimension) =>
        dimension.values.find((value) => value.valueId === valueId)
      )
      if (foundDimension) {
        const foundValue = foundDimension.values.find((value) => value.valueId === valueId)
        return foundValue[`${propertyType}${language ? language : ''}`]
      }
      return null
    }
    return null
  }

  function getValueCode(valueId) {
    return getValueProperty(valueId, 'valueCode')
  }

  function getValueName(valueId) {
    return getValueProperty(valueId, 'valueName', LFC_LANGUAGE)
  }

  function checkSelectedValuesOnChange(selectedValues) {
    const newConstraints = checkConstraint(selectedValues, lfcItem.constraintsRules)
    const notOkValues = selectedValues.filter((selectedValue) =>
      newConstraints.find(
        (constraint) =>
          constraint.valueId === selectedValue &&
          (constraint.checkStatus === 'DENYFOR' || constraint.checkStatus === 'NEEDSANYOF')
      )
    )
    if (notOkValues.length > 0) {
      const correctionInformation = notOkValues.map((notOkValue) => ({
        dimensionId: lfcItem.dimensions.find((dimension) =>
          dimension.values.find((value) => value.valueId === notOkValue)
        ).dimensionId,
        constraint: newConstraints.find((constraint) => constraint.valueId === notOkValue),
      }))
      // TODO--LFC: snygga till det här?
      const okSelectedValues = selectedValues.filter((selectedValue) => {
        const foundNotOkValue = notOkValues.find((notOkValue) => notOkValue === selectedValue)
        if (foundNotOkValue) {
          return false
        }
        return true
      })
      const correctedSelectedValues = okSelectedValues.slice()
      notOkValues.forEach((notOkValue) => {
        const dimensionForNotOkValue = lfcItem.dimensions.find((dimension) =>
          dimension.values.find((value) => value.valueId === notOkValue)
        )
        // TODO--LFC: snygga till det här?
        const firstOkValueFoundInDimension = dimensionForNotOkValue.values.find((value) => {
          const foundConstraint = newConstraints.find((constraintRule) => constraintRule.valueId === value.valueId)
          if (foundConstraint) {
            return false
          }
          return true
        })
        correctedSelectedValues.push(firstOkValueFoundInDimension.valueId)
      })
      // TODO--LFC: fixa nedan...
      setConstraints(checkConstraint(correctedSelectedValues, lfcItem.constraintsRules))
      setCorrectionInformation(correctionInformation)
      onChange(correctedSelectedValues)
    } else {
      // TODO--LFC: fixa nedan...
      setConstraints(newConstraints)
      setCorrectionInformation([
        {
          dimensionId: null,
          constraint: null,
        },
      ])
      onChange(selectedValues)
    }
  }

  return (
    // For MOK, the lfcSlice of MOK store is used instead
    // <Provider store={lfcStore}>
    <Styled.hideDimensionsStyles visibleDimenesionsIds={memoVisibileDimensionsIds}>
      <Configurator
        language={LFC_LANGUAGE}
        messages={LFC_MESSAGES}
        dimensions={getSelectableValues(lfcItem.dimensions, constraints)} // OK, MOK
        dimsHiddenFromMarkets={
          // only works for single config product in configResult, equivalent to current implementation in lfc-frontend
          configResult.configProducts[0].editorial.dimsHiddenFromMarkets
        }
        getDimensionName={getDimensionName}
        getValueCode={getValueCode}
        getValueName={getValueName}
        selectedValues={chosenValues}
        correctionInformation={correctionInformation}
        onChange={checkSelectedValuesOnChange}
        handleHandingChange={() => {}} // handled by DM instead
        renderDimensionDescriptions={true}
      />
    </Styled.hideDimensionsStyles>
    // For MOK, the lfcSlice of MOK store is used instead
    // </Provider>
  )
}

Lfc.propTypes = {
  lfcItem: PropTypes.shape({
    contextId: PropTypes.string,
    namedConfigCode: PropTypes.string,
    dimensions: PropTypes.array,
    constraintsRules: PropTypes.array,
  }).isRequired,
  chosenValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  configResult: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Lfc
